





















import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator';


@Component
export default class Title extends Vue {
  @Prop() templateIds!: string[];
  @Ref('btnRef') btn!: HTMLElement;

  @Emit('success')
  public onSuccess(e) {
    console.log('success', e.detail);
    return e.detail;
  }

  @Emit('fail')
  public onFail(e) {
    console.log('fail', e.detail);
    return e.detail;
  }

  mounted() {
    if (this.btn) {
      const p = this.btn.parentElement!.style.position;
      if (!p) {
        this.btn.parentElement!.style.position = 'relative';
      }
    }
  }
}
